// Module
var code = `<span class="tag"> <ng-transclude></ng-transclude> <a class="text-danger" ng-click="tagController.onRemove()"> <i class="fa fa-times"></i> </a> </span> `;
// Exports
module.exports = code;